import type { ICategory } from 'garden-common';
import {api} from './index';
import { handleAxiosError } from './error-handler.util';




// Looks disgusting because eslint wants to avoid blocks on an arrow function with a single return 
//  FIXME: refactor this and the rest of the code to fix the linting 
export const getAllCategories = async (text = 'null'): Promise<ICategory[]> =>
  api.get(`/categories/all/${text}`).then(
    (res: { data: { cateogories: ICategory[]; }; }) =>
      res.data.categories as ICategory[]
  );



export const createCategory = async (data: ICategory) => {
  try {
    const res = await api.post(`/categories/create`, data).then(res => {
      if (res.status === 201) {
        return res.data.category;
      } else {
        return res;
      }
    });
    return res;
  } catch (error) {
    handleAxiosError(error);
    return error.response?.data?.errors;
  }
};

export const updateCategory = async (id: string, data: { updates: ICategory; }) => {
  try {
    const ret = await api.put(`/categories/update/${id}`, data).then(res => {
      console.log(res.data, res.status);
      if (res.status === 201) {
        return res.data.categories;
      } else {
        return res;
      }
    });
    return ret;
  } catch (error) {
    return error.response?.data?.errors;
  }
};

// export let updateCategory = async (
// 	id: string,
// 	body: { updates: { title: string; description: string } }
// ) => {
// 	try {
// 		// Attempt to update the category.
// 		const response = await api.put(`/categories/update/${id}`, body)

// 		// If the response is successful and we have a status indicating success.
// 		if (response.status === 201 || response.status === 200) {
// 			const updatedCategory = response.data.category
// 			console.log("Got Subcats", updatedCategory)

// 			// Now get all subcategories.
// 			const allSubcatsResponse = await getAllSubcategories(1000)
// 			console.log("Got Subcats", allSubcatsResponse)

// 			} else {
// 				throw new Error('Failed to fetch subcategories')
// 			}
// 		} else {
// 			throw new Error(`Failed to update category with status: ${response.status}`)
// 		}
// 	} catch (error) {
// 		// If error.response is available it means Axios error with a server response.
// 		// If not, it could be an error while setting up the request.
// 		return error.response ? error.response.data : { message: error.message }
// 	}
// }

export const deleteCategory = async (id: string) => {
  return await api.delete(`/categories/create/${id}`).then(res => {
    return res.data.categories;
  });
};

export interface FetchCategoriesData {
  categories: ICategory[];
}

export async function fetchCategories(searchString?: string): Promise<FetchCategoriesData> {
  const res = await api.get(`categories/all/${searchString ? searchString : ''}`);

  return res.data;
}

export async function fetchCategoryByName(name: string): Promise<ICategory> {
  const res = await api.get('/categories/name/' + name);

  return res.data.categories;
}
